import { journeyPostJson } from 'src/utils/journeyApi';

export const apiLogin = (params: Record<string, unknown>, next: string | string[] | null) =>
  journeyPostJson(`/login`, params, { params: { next } });

export const apiSignup = (params: any) => journeyPostJson('/signup', params);
export const apiForgotPassword = (params: Record<string, unknown>) => journeyPostJson('/forgot-password', params);
export const apiResetPassword = (params: Record<string, string>) => journeyPostJson('/reset-password', params);
export const apiCheckEmail = (email: string) => journeyPostJson('/signup-validate/check-email', { email });
